import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { observe } from '@web/util/loading/loading';
import { route as r } from '@util/route';
import { WineryIntegrationsService } from '../winery-integrations.service';
import { DWSIntegrationConnector } from '@interfaces/dws/integration';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { AccountsService } from '@services/accounts.service';

@Injectable({
  providedIn: 'root'
})
export class IntegrationNameResolverService implements Resolve<DWSIntegrationConnector> {
  constructor(
    private wineryIntegrationsService: WineryIntegrationsService,
    private accountService: AccountsService,
  ) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<DWSIntegrationConnector> {
    const integrationId = r.access(route).param('integrationId');
    if (!integrationId) return Promise.resolve(null) as any;

    const details = await observe(this.wineryIntegrationsService.getIntegrations()).pipe(
      catchError(() => of([])),
      map((integrations: DWSIntegrationConnector[]) => integrations.find(integration => integration.integration?.id === integrationId)?.integration?.name)
    ).toPromise();
    
    return Promise.resolve(details) as any;
  }
}